import BreadcrumbsPath from "./breadcrumbsPathEntity";
import LinkItem from "./linkItemEntity";

export default class CertificateContentPage {
    public id: string;
    public title: string;
    public heroImage: string;
    public content: string;
    public builderLinks: LinkItem[];
    public professionalLinks: LinkItem[];
    public linkItems: LinkItem[];
    public breadcrumbsPath: BreadcrumbsPath;
    
    constructor() {
      this.id = "";
      this.title = "";
      this.heroImage = "";
      this.content = "";

      this.linkItems = [];
      this.builderLinks = [];
      this.professionalLinks = [];

      this.breadcrumbsPath = new BreadcrumbsPath();
    }
  }


// WEBPACK FOOTER //
// ./src/api/certificatesContentPageEntity.ts